import React from 'react';
import classnames from 'classnames';
import TableBody from './TableBody';
import TableFoot from './TableFoot';
import TableHeader from './TableHeader';

class SAWBody extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      hoverIndex: null,
    };

    this.updateHoverIndex = this.updateHoverIndex.bind(this);
  }

  updateHoverIndex(hoverIndex) {
    this.setState({
      hoverIndex,
    });
  }

  render() {
    const {
      teamOrder,
      members,
      scores,
      scorecardsCount,
      skillsOrder,
      itemLabel,
      sortDirection,
      sortColumn,
      startDate,
      endDate,
    } = this.props;
    const {hoverIndex} = this.state;
    // if there are more than 6 skills, we need to freeze the first column and
    // the last two columns and scroll the middle
    const freeze = skillsOrder.length > 6;

    return (
      <div className="widget-body">
        <div className={classnames('stats-wrapper', freeze ? 'freeze' : '')}>
          <table className="stats-table">
            <TableHeader
              {...{skillsOrder, sortDirection, sortColumn, hoverIndex}}
              label={itemLabel}
              headerClick={this.props.headerClick}
              updateHoverIndex={this.updateHoverIndex}
              headerTooltip={this.props.headerTooltip}
              skillsOrderChange={this.props.skillsOrderChange}
              skillsOrderSelected={this.props.skillsOrderSelected}
              startDate={startDate}
              endDate={endDate}
            />
            <TableFoot
              {...{skillsOrder, scores, scorecardsCount, hoverIndex}}
              updateHoverIndex={this.updateHoverIndex}
            />
            <TableBody
              {...{
                teamOrder,
                skillsOrder,
                members,
                scores,
                itemLabel,
                hoverIndex,
              }}
              location={this.props.location}
              nameClick={this.props.nameClick}
              totalsClick={this.props.totalsClick}
              updateHoverIndex={this.updateHoverIndex}
              rowTooltip={this.props.rowTooltip}
              onCreatePlan={this.props.onCreatePlan}
              startDate={startDate}
              endDate={endDate}
            />
          </table>
        </div>
      </div>
    );
  }
}

SAWBody.displayName = 'SAW-Body';
export default SAWBody;
